import QuadraticSpline from "@/math/QuadraticSpline";
import { cardFromRelative, relativeScaleFromBoard } from "@/math/coordinate-transform";
import { divided, minus, plus, rectangle, times } from "@/math/coordinates";
import type { BoardCoordinate, RelativeCoordinate, WindowCoordinate } from "@/model/coordinates";
import { cardSize } from "@/store/board";

export function findDeleteIconPos(
  from: RelativeCoordinate,
  fromScale: number,
  to: RelativeCoordinate,
  offset: BoardCoordinate, // Offset of the 'from' sticky if it was moved into the viewport when enlarged
): WindowCoordinate | undefined {
  const unscaledSize = cardSize();
  const scaledSize = times(unscaledSize, fromScale);

  // If the from sticky is moved into the viewport when enlarged, the sticky (fromRect)
  // won't be centered on the link 'from' position. Here, we're correctly positioning the fromRect
  const adjustment = relativeScaleFromBoard(offset);
  const adjustedFrom = plus(from, adjustment);

  // make the rectangle a bit bigger than the sticky, this is the space the delete icon will be in
  const fromRect = rectangle({ center: adjustedFrom, size: times(scaledSize, 1.13) });
  const toRect = rectangle({ center: to, size: times(unscaledSize, 1.13) });
  const spline = QuadraticSpline.forLink(from, to);
  const pos = spline.pointOutsideRectangles(fromRect, toRect);
  if (pos) {
    // Again, if the enlarged sticky is not centered on the link 'from' position,
    // move the delete icons so they appear above the links
    const adjustedPos = minus(pos, adjustment);
    return cardFromRelative(divided(minus(adjustedPos, from), fromScale));
  }
}
